declare global {
  interface Window {
    dataLayer?: object[];
  }
}

function isGTMLoaded() {
  if (typeof window !== 'undefined' && window.dataLayer && Array.isArray(window.dataLayer)) {
    return window.dataLayer.some((item: { event: string }) => item.event === 'gtm.js');
  }
  return false;
}

export const GA = {
  _log: (data?: Record<string, unknown>) =>
    process.env.NEXT_PUBLIC_GA_ENVIRONMENT_ID === 'stage' && console.info('Google Analytics: Data pushed.', data),

  _pushData(data: Record<string, unknown>) {
    if (typeof window !== 'undefined') {
      if (window.dataLayer) {
        window.dataLayer.push(data);
        GA._log(data);
      } else {
        console.warn('Google Analytics: "dataLayer" does not exist.', 'Missed Data ->', data);
      }
    }
  },

  _safeTrack(trackingFunction: () => void, maxRetries = 5, retryDelay = 1000): Promise<void> {
    return new Promise((resolve, reject) => {
      let retries = 0;

      const attemptTracking = () => {
        if (isGTMLoaded()) {
          trackingFunction();
          resolve();
        } else if (retries < maxRetries) {
          console.warn(`GTM not loaded. Retry attempt ${retries + 1} of ${maxRetries}`);
          retries++;
          setTimeout(attemptTracking, retryDelay);
        } else {
          console.error('Max retries reached. GTM not loaded.');
          reject(new Error('GTM failed to load after maximum retries'));
        }
      };

      !process.env.CI && attemptTracking();
    });
  },

  sendEvent: ({ event = 'generic_event', event_name, ...params }: { event?: string; event_name: string } & Record<string, unknown>) => {
    return GA._safeTrack(() => {
      GA._pushData({ event, event_name, [event_name]: params });
    });
  },

  sendRawEvent: ({ event = 'generic_event', ...params }: { event?: string } & Record<string, unknown>) => {
    return GA._safeTrack(() => {
      GA._pushData({ event, ...params });
    });
  },
};
